import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Stack from '@mui/material/Stack';
import AppTheme from '../../../../ui/mui/shared-theme/AppTheme';
import ColorModeSelect from '../../../../ui/mui/shared-theme/ColorModeSelect';
import SignInCard from './SignInCard';
import { createContext, JSX, useContext, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router';
import { RootRouter } from '../../../../app';
import Content from './Content';
import Alerts from '../../../components/alerts/Alerts';
import { Typography, useColorScheme } from '@mui/material';
import { auth } from '../../../services/auth';

export function LogInPage(props: { disableCustomTheme?: boolean }) {
  const { mode, setMode } = useColorScheme();
  let navigate = useNavigate();
  let location = useLocation();
  let auth = useAuth();
  let { from } = location.state || { from: { pathname: "/" } };

  React.useEffect(() => {
    auth.authActions.loginAuto()
  }, [])

  React.useEffect(() => {
    if (auth.authState.row.usuario) {
      let navFrom = from.pathname
      navigate(navFrom);
    }
  }, [auth.authState.row])

  setMode("light");
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <ColorModeSelect sx={{ position: 'fixed', top: '1rem', right: '1rem' }} />
      <Alerts show={auth.authState.showAlert} handleClose={auth.authActions.clearAlert} menssage={auth.authState.msg} tipoAlerta='error' />
      <Stack
        direction="column"
        component="main"
        sx={[
          {
            justifyContent: 'center',
            height: 'calc((1 - var(--template-frame-height, 0)) * 100%)',
            marginTop: 'max(40px - var(--template-frame-height, 0px), 0px)',
            minHeight: '100%',
            flex: 1,
          },
          (theme) => ({
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              zIndex: -1,
              inset: 0,
              backgroundImage:
                'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
              backgroundRepeat: 'no-repeat',
              ...theme.applyStyles('dark', {
                backgroundImage:
                  'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
              }),
            },
          }),
        ]}
      >
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          sx={{
            justifyContent: 'center',
            gap: { xs: 6, sm: 12 },
            p: 2,
            mx: 'auto',
          }}
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            sx={{
              justifyContent: 'center',
              gap: { xs: 6, sm: 12 },
              p: { xs: 2, sm: 4 },
              m: 'auto',
              alignItems: "center"
            }}
          >

            <SignInCard />

          </Stack>
        </Stack>
      </Stack>
    </AppTheme>
  );
}

function useProvideAuth() {
  const [authState, setAuthState] = useState<any>({ loading: false, msg: "", row: {}, showAlert: false, status: "ok" });

  const login = async (user: string, pass: string) => {
    console.log("chamou login", [user, pass]);
    setAuthState((state: any) => ({ ...state, loading: true, status: "ok", msg: "" }))
    //fazer a autenticaçao do usuario
    let resp = await auth.logIn(user, pass);
    console.log("resp", resp);
    //fazer a autenticaçao do usuario
    if (resp.status === "ok") {
      setAuthState((state: any) => ({ ...state, row: { usuario: resp.row }, loading: false, status: "ok" }))
    } else {
      setAuthState((state: any) => ({ ...state, loading: false, status: resp.status, msg: resp.mensagem, showAlert: true }))
    }

  };

  const logoff = () => {
    setAuthState((state: any) => ({ ...state, row: {} }))
  }

  const clearAlert = () => {
    setAuthState((state: any) => ({ ...state, showAlert: false }))
  }

  const loginAuto = async () => {
    let respSignFast = await auth.singInFast()
    if (respSignFast.status === "ok") {
      setAuthState((state: any) => ({ ...state, row: { usuario: respSignFast.row }, loading: false, status: "ok" }))
    }
  }

  const authActions = { login, clearAlert, logoff, loginAuto }
  return {
    authState,
    authActions,
    version: "0.1.6.2"
  };
}

const authContext = createContext<any>({});

export function ProvideAuth({ children }: any) {
  const auth = useProvideAuth();
  return (
    <authContext.Provider value={auth} >
      {children}
    </authContext.Provider>
  );
}

export function useAuth() {
  return useContext(authContext);
}

export function RequireAuth({ children }: { children: JSX.Element }) {
  let useauth = useAuth();
  let location = useLocation();

  if (!useauth.authState.row.usuario) {
    return <Navigate to="/logIn" state={{ from: location }} replace />
  }

  return children

}